import React, {Component} from 'react';
import h from 'react-hyperscript';
import './ReportCardSingle.scss';
import BasicCard from 'Components/Cards/BasicCard';
import Breadcrumbs from 'Pages/ReportCardSingle/Breadcrumbs/Breadcrumbs';
/* eslint-disable max-len */
import BreadcrumbsGuest from 'Pages/ReportCardSingle/Breadcrumbs/BreadcrumbsGuest';
import TransformationProgressDetail from 'Pages/ReportCardSingle/TransformationProgressDetail/TransformationProgressDetail';
import ProductUsage from 'Pages/ReportCardSingle/ProductUsage/ProductUsage';
import ProductUsageDetail from 'Pages/ReportCardSingle/ProductUsageDetail/ProductUsageDetail';
import ProgramAdvancement from 'Pages/ReportCardSingle/ProgramAdvancement/ProgramAdvancement';
import ChromebookDevices from 'Pages/ReportCardSingle/ChromebookDevices/ChromebookDevices';
import ProgramAdvancementDetail from 'Pages/ReportCardSingle/ProgramAdvancementDetail/ProgramAdvancementDetail';
import FourCs from 'Pages/ReportCardSingle/FourCs/FourCs';
import DriveUserProfiles from 'Pages/ReportCardSingle/DriveUserProfiles/DriveUserProfiles';
import ClassroomActivity from 'Pages/ReportCardSingle/ClassroomActivity/ClassroomActivity';
import SurveyStatus from 'Pages/ReportCardSingle/SurveyStatus/SurveyStatus';
import content from 'Assets/data/report-card-single.json';
import gsuite from 'Assets/data/gsuite.json';
import globalContent from 'Assets/data/globals.json';
import {REPORT} from 'Src/utils/gtm/const';
import {pushEvent as pushGTMEvent} from 'Src/utils/gtm';
import {AppBar, Button} from '@material-ui/core';
import {h4, footnote} from 'Components/Typography/Typography';
import {formatDateChartLegend} from 'Src/utils/utils';

/* eslint-enable max-len */

import {
  ENDPOINTS,
  getSum,
  getAvg,
  getIndexByProperty,
  getPercentValue,
  setZeroIfInvalidNumber,
  isArrayEmpty,
  getAccessToken,
  fetchTimeout,
} from 'Src/utils/utils';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import ErrorMessage from 'Components/ErrorMessage/ErrorMessage';
import Banner from '../../components/Banner/Banner';

class ReportCardSingle extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      isLoaded: false,
      transformationResourcesLoaded: false,
      reportDataLoaded: false,
      reportListLoaded: false,
      isLoadedProductWindows: true,
      loadingContent: content.loading,
      reportData: null,
      sharedUsers: [],
      districtMetrics: null,
      errorMessage: null,
      totalNumUsers: null,
      dynamicGraphSize: false,
      currWindow: null,
      prevWindow: null,
      surveyStatus: {
        share_survey_url: '',
      },
      surveyOpenPeriod: this.props.userStatus.survey_open_period_flag,
      latestSurveyComplete: this.props.userStatus.user_survey_state,
      nextSurveyDate: this.props.userStatus.dates.next_survey_date,
      activeComponent: 'ReportAvailableState',
      reportList: null,
      latestReport: null,
      reportMissingDataNotFound: false,
      errorPage: undefined,
      reportDataTimerStarted: false,
      reportDataTimeoutReached: false,
    };

    this.reportCardRef = React.createRef();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userStatus !== this.props.userStatus) {
      this.setLatestSurveyComplete();
    }

    if (this.props.productWindowsLoading !=
        prevProps.productWindowsLoading && this.props.productWindowsLoading) {
      this.setLoadingContent(content.loading_product_windows);
      this.setProductWindowLoaded(false);
    }
    if (this.props.productWindowsLoading !=
        prevProps.productWindowsLoading && !this.props.productWindowsLoading) {
      this.setProductWindowLoaded(true);
      this.setIsLoaded(false);
      this.loadComponentData();
    }
  }

  componentDidMount() {
    if (!this.props.productWindowsLoading) {
      this.loadComponentData();
    } else {
      this.setLoadingContent(content.loading_product_windows);
    }
  }

  loadComponentData() {
    this._isMounted = true;
    this.fetchTransformationResources();
    this.fetchReportData();
    this.fetchReportList();
    this.setLatestSurveyComplete();

    this.setState({
      reportLoading: true,
      reportDataTimerStarted: false,
      reportDataTimeoutReached: false,
    });

    if (this.props.userStatus.survey_open_period_flag) {
      fetch(ENDPOINTS.SURVEY_STATUS, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.props.idToken,
          'X-CSRF-Token': this.props.csrf,
        },
        body: JSON.stringify({
          access_token: getAccessToken(this.props.googleUser),
        }),
      })
          .then((response) => response.json())
          .then(
              (result) => {
                if (result.data) {
                  if (this._isMounted) {
                    this.setSurveyStatus(result.data);
                  }
                } else {
                  console.error('Result needs attention: ', result);
                }
              },
              (error) => {
                console.error('No result', error);
              }
          );
    }
  }

  setReportData(value) {
    if (this._isMounted) {
      const {
        cur_report_period: curPeriod,
        prev_report_period: prevPeriod,
      } = value.report_data;

      let reportData; let reportDataPrev;

      const reportSlug = this.props.match.params.reportId;
      const isCurrent = reportSlug === curPeriod.report_name_slug;

      if (isCurrent) {
        reportData = curPeriod;
        reportDataPrev = this.getPrevReportData(prevPeriod, 0) || {};
      } else if (!isArrayEmpty(prevPeriod)) {
        const index = prevPeriod.findIndex(
            (report) => report.report_name_slug === reportSlug
        );
        reportData = prevPeriod[index];
        reportDataPrev =
          this.getPrevReportData(prevPeriod, index + 1) || {};
      }

      if (reportData && reportData.product_metrics_history.length < 12 &&
          !this.state.reportDataTimeoutReached) {
        if (!this.state.reportDataTimerStarted) {
          this.setReportDataTimerStarted(true);
          // Checks a maximum of 30 seconds for complete data
          setTimeout(() => {
            this.setReportDataTimeoutReached(true);
          }, 30000);
        }
        return this.fetchReportData();
      }

      if (reportData) {
        this.props.setReportName(reportData.report_name);

        this.setState({reportData, reportDataPrev}, () => {
          const productMetrics = this.state.reportData.product_metrics_history;
          const productMetricsPrev =
            this.state.reportDataPrev.product_metrics_history;

          if (this.hasProductMetricsHistory(productMetrics)) {
            this.getTotalNumUsers(this.state.reportData);

            if (this.hasProductMetricsHistory(productMetricsPrev)) {
              this.getTotalNumUsers(this.state.reportDataPrev, true);
            }
          } else {
            this.setIsLoaded(true);
          }
        });
      } else {
        this.setErrorMessage('No report found.');
        this.setIsLoaded(true);
      }
    }
  }

  getPrevReportData(prevReportPeriods, index) {
    if (!prevReportPeriods || isArrayEmpty(prevReportPeriods)) return null;
    return prevReportPeriods[index];
  }

  hasProductMetricsHistory(productMetrics) {
    return productMetrics && !isArrayEmpty(productMetrics);
  }

  renderBanner() {
    const {reportData} = this.state;
    return reportData && reportData.survey_results &&
      reportData.survey_results.__num_respondents < 3 ? h(Banner, {
        key: `report-single__banner__key`,
        message: content.banner.replace(
            'XX%', reportData.survey_results.__num_respondents
        ),
      }, null) : null;
  }

  fetchReportData() {
    fetch(ENDPOINTS.REPORT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.props.idToken,
        'X-CSRF-Token': this.props.csrf,
      },
      body: JSON.stringify({
        district_report_card_id: this.getReportId(),
        district_id: this.props.match.params.districtId,
        access_token: getAccessToken(this.props.googleUser),
      }),
    })
        .then((response) => response.json())
        .then(
            (result) => {
              if (result.message) {
                this.setErrorMessage(result.message);
              } else {
                this.setErrorMessage(null);
                this.setReportData(result);
                this.setState({
                  ...this.state,
                  districtName: result.district_name,
                  sharedUsers: result.shared_users,
                  reportAvailableDate: result.report_available_date,
                  currWindow: formatDateChartLegend(
                      result.current_product_metrics_date),
                  prevWindow: formatDateChartLegend(
                      result.previous_product_metrics_date),
                });
              }
            },
            (err) => {
              this.setIsLoaded(true);
              this.setErrorMessage('Something went wrong');
            }
        );
  }

  fetchTransformationResources() {
    fetch(ENDPOINTS.REPORT_RESOURCES_LIST, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.props.idToken,
        'X-CSRF-Token': this.props.csrf,
      },
    })
        .then((response) => response.json())
        .then(
            (result) => {
              this.setTransformationResources(result.recommended_resources);
            },
            () => {
              this.setErrorMessage('Something went wrong');
            }
        );
  }

  getReportId() {
    const href = window.location.href;
    let reportId = null;
    if (href.includes('&print=true')) {
      reportId = href.substring(
          href.lastIndexOf('?') + 1,
          href.lastIndexOf('&')
      );
    } else {
      const n = href.lastIndexOf('?');
      reportId = href.substring(n + 1);
    }
    return reportId;
  }

  checkIfPrint() {
    const reportCardEl = this.reportCardRef.current;
    const loadingIndicatorsVisible = reportCardEl ?
      Boolean(
          this.reportCardRef.current.querySelectorAll(
              '.loading-indicator'
          ).length
      ) :
      true;
    const reportLoaded = !loadingIndicatorsVisible;
    const href = window.location.href;

    if (href.includes('&print=true') && reportLoaded) {
      if (this.printOnLoad) {
        window.cancelAnimationFrame(this.printOnLoad);
      }
      let framesRendered = 0;
      const maxFramesRendered = 61;
      const print = () => {
        if (framesRendered < maxFramesRendered) {
          ++framesRendered;
          this.requestFrame = window.requestAnimationFrame(print);
          return;
        }
        window.cancelAnimationFrame(this.requestFrame);
        pushGTMEvent(REPORT.TAG, {
          event: REPORT.EVENT,
          action: {report_action: REPORT.ACTION.DOWNLOAD},
        });
        window.print();
      };
      print();
    } else {
      this.printOnLoad = window.requestAnimationFrame(() => {
        this.checkIfPrint();
      });
    }
  }

  setDistrictMetrics(value) {
    if (this._isMounted) {
      this.setState({
        districtMetrics: value,
      });
    }
  }

  getTotalNumUsers(reportData, isPrev) {
    const numTeachers = reportData.district_config.num_teachers;
    const numStudents = reportData.district_config.num_students;
    let totalUsers = getSum([numTeachers, numStudents]);

    if (totalUsers === 0 || totalUsers === null) {
      totalUsers = getAvg(this.checkAverageWeeklyNumUsers(reportData));
    }

    const key = isPrev ? 'totalNumUsersPrev' : 'totalNumUsers';
    this.setTotalNumUsers(key, totalUsers);
  }

  checkAverageWeeklyNumUsers(reportData) {
    const weeklyNumUsers = reportData.product_metrics_history.map((week) => {
      return week;
    });
    return weeklyNumUsers;
  }

  getWeeklyProductValues(productMetrics, isPrev) {
    const totalNumUsers = isPrev ?
      this.state.totalNumUsersPrev :
      this.state.totalNumUsers;

    const relevantData = productMetrics.map((week) => {
      const productMetrics = gsuite.products.map((product) => {
        const formula = week[product.id] / totalNumUsers;
        const metric = setZeroIfInvalidNumber(formula);
        return {
          product: product.id,
          metric: metric,
          apiValue: week[product.id] || 0,
          percentage: `${getPercentValue(metric)}%` || 0,
        };
      });
      return {
        date: week.date,
        metrics: productMetrics,
      };
    });
    return relevantData;
  }

  getProductWeeklyValues(productMetrics, isPrev) {
    if (!this.hasProductMetricsHistory(productMetrics)) return;

    const weeklyData = this.getWeeklyProductValues(productMetrics, isPrev);
    const products = gsuite.products.map((product) => {
      const weeklyDataByProduct = weeklyData.map((week) => {
        const index = getIndexByProperty(
            week.metrics, 'product', product.id
        );
        return week.metrics[index];
      });

      return {
        product: product.id,
        id: product.id,
        productName: product.title,
        productIcon: {
          standard: product.icon,
          retina: product.icon_2x,
        },
        metrics: weeklyDataByProduct,
      };
    });
    return products;
  }

  setTransformationResources(value) {
    this.setState({
      transformationResources: value,
    });
  }

  setTotalNumUsers(key, value) {
    this.setState({
      [key]: value,
    }, () => {
      this.setIsLoaded(true);
    });
  }

  get hasSurveyResults() {
    const surveyResults = this.state.reportData.survey_results;

    if (!surveyResults) {
      return false;
    }

    const surveyResultsIsObject = typeof surveyResults === 'object';
    const surveyResultsKeys =
      surveyResultsIsObject && Object.keys(surveyResults);
    const nonEmptyObject =
      surveyResultsKeys ? surveyResultsKeys.length > 0 : false;
    const hasValuesWithAverages = () => {
      return surveyResultsKeys.some((key) => {
        const value = surveyResults[key];

        return value && typeof value.__average === 'number';
      });
    };

    return nonEmptyObject &&
      surveyResults.__num_respondents !== 0 &&
      hasValuesWithAverages();
  }

  setErrorMessage(value) {
    this.setState({
      isLoaded: Boolean(value),
      errorMessage: value,
    });
  }

  setIsLoaded(value) {
    this.setState({
      isLoaded: value,
    }, () => {
      this.checkIfPrint();
    });
  }

  setProductWindowLoaded(value) {
    this.setState({
      isLoadedProductWindows: value,
    });
  }

  fetchReportList() {
    return fetchTimeout(ENDPOINTS.REPORT_LIST, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.props.idToken,
        'X-CSRF-Token': this.props.csrf,
      },
      body: JSON.stringify({
        access_token: getAccessToken(this.props.googleUser),
        district_id: this.props.match.params.districtId,
      }),
    })
        .then((response) => {
          return response.json();
        })
        .then(
            (result) => {
              if (result.report_cards) {
                if (result.report_cards.length < 1) {
                  this.setReportList(null);
                } else {
                  this.setReportList(result.report_cards);
                  this.setState({
                    ...this.state,
                    sharedUsers: result.shared_users,
                  });
                }
              } else {
                console.error('Result needs attention: ', result);
              }
            }
        ).catch((error) => {
          if (error.name === 'AbortError') {
            this.setState({
              errorPage: 'timeout',
              isLoaded: true,
            });
          }
        });
  }

  setSurveyStatus(data) {
    this.setState({
      surveyStatus: data,
    });
  }

  reportMissingData(reportList) {
    return (
      reportList &&
      Array.isArray(reportList) &&
      reportList.some((report) => report.missing_data)
    );
  }

  isBeforeReportAvailableDate(reportAvailableDate) {
    const dateAvailable = new Date(reportAvailableDate);
    const dateNow = new Date();

    return dateNow < dateAvailable;
  }

  setReportList(data) {
    this.setState(
        {
          reportList: data,
        },
        () => {
          if (this.state.reportList && this.state.reportList.length > 0) {
            this.props.setLatestReportName(
                this.state.reportList[0].report_card_name);
            this.setLatestReport(this.state.reportList[0]);
          }
        }
    );
    this.setLatestSurveyComplete();
  }

  setReportDataTimerStarted(data) {
    this.setState({
      reportDataTimerStarted: data,
    });
  }

  setReportDataTimeoutReached(data) {
    this.setState({
      reportDataTimeoutReached: data,
    });
  }

  setLatestReport(value) {
    this.setState({
      latestReport: value,
    });
  }

  setLatestSurveyComplete() {
    if (this._isMounted) {
      let value;

      if (
        this.props.userStatus.user_survey_state === 'Not Started' ||
        this.props.userStatus.user_survey_state === 'Partial'
      ) {
        value = false;
      } else {
        value = true;
      }

      this.setState(
          {
            latestSurveyComplete: value,
          },
          () => {
            this.checkSurveyStatus();
          }
      );
    }
  }

  setLoadingContent(value) {
    this.setState({
      loadingContent: value,
    });
  }

  /**
   * Below are the different configurations for our Survey states:

   * Survey is Available
   * There is a new survey available, but the user has not yet taken it.
   *
   *  surveyOpenPeriod: true
   *  latestSurveyComplete: false
   *
   * Survey is Complete
   * The user has completed the latest survey in our open survey period, but
   * the latest report is not yet available.
   *
   */
  checkSurveyStatus() {
    const surveyNotComplete = !this.state.latestSurveyComplete;
    const surveyIsAvailable =
      this.state.surveyOpenPeriod && surveyNotComplete;
    const surveyStatusComponent = surveyIsAvailable ?
      'survey_available' : 'survey_complete';

    this.setSurveyStatusComponent(surveyStatusComponent);
  }

  setSurveyStatusComponent(value) {
    this.setState({
      activeComponent: value,
    });
  }

  render() {
    if (this.state.isLoaded && this.state.isLoadedProductWindows) {
      if (this.state.errorMessage) {
        return (
          h(ErrorMessage, {
            message: this.state.errorMessage,
          }, null)
        );
      } else {
        const {dynamicGraphSize, screenWidth} = this.props;
        const {reportData, reportDataPrev} = this.state;
        const {product_metrics_history: productMetrics} = reportData;
        const {product_metrics_history: productMetricsPrev} = reportDataPrev;
        const transformationProgContent =
          content.transformation_progress_detail;
        const hasSurveyResults = this.hasSurveyResults;
        const hasProductMetricsHistory =
          this.hasProductMetricsHistory(productMetrics);
        const surveyStatusContent =
          content.transformation_survey_detail[this.state.activeComponent];
        const surveyDateClosed =
          new Date(reportData.report_available_date) <= new Date();

        return (
          h('div', {
            className: 'report-card--single',
            ref: this.reportCardRef,
          }, [
            h(AppBar, {
              className: 'distance-learning__banner',
              position: 'static',
            }, [
              h('p', [
                'New & Popular Resources from Google:',
                h(Button, {
                  href: 'https://edu.google.com/intl/ALL_us/workspace-for-education/editions/education-plus/roi-calculator/?utm_source=5b_event&utm_medium=email&utm_campaign=FY-Qr-campaignname_cta.&utm_content=-&utm_term=-',
                  target: 'blank',
                  className: 'distance-learning__button',
                }, 'Education Plus Impact Calculator'),
                h(Button, {
                  href: 'https://skillshop.exceedlms.com/student/path/549945-google-tools-for-in-person-learning?sid=96608218-a9dd-4584-a60f-a57cf8a5d0b6&sid_i=0',
                  target: 'blank',
                  className: 'distance-learning__button',
                }, 'Google Tools for In-Person Learning Course'),
                h(Button, {
                  href: 'https://skillshop.exceedlms.com/student/path/479480-google-classroom-course?locale=en',
                  target: 'blank',
                  className: 'distance-learning__button',
                }, 'Google Classroom Course'),
              ]),
            ]),
            h('div', {
              className: 'container',
            }, [
              this.props.userStatus.admin_level === 'Admin' ?
              h(Breadcrumbs, {
                key: 'breadcrumb__key',
                districtName: this.state.districtName,
                reportCardName: this.state.reportData.report_name,
                reportButton: content.report_button,
                userStatus: this.props.userStatus,
                sharedUsers: this.state.sharedUsers,
                setSharedUsers: (users) => this.setState({
                  ...this.state,
                  sharedUsers: users,
                }),
                googleUser: this.props.googleUser,
                csrf: this.props.csrf,
                idToken: this.props.idToken,
                districtId: this.props.match.params.districtId,
                reportId: this.getReportId(),
              }, null) :
              h(BreadcrumbsGuest, {
                key: 'breadcrumb__key',
                districtName: this.state.districtName,
                reportCardName: this.state.reportData.report_name,
                reportButton: content.report_button,
                googleUser: this.props.googleUser,
                csrf: this.props.csrf,
                idToken: this.props.idToken,
                districtId: this.props.match.params.districtId,
                reportId: this.getReportId(),
              }, null),

              h('div', {
                key: `report-single__row-1__key`,
                className: 'row',
              }, [
                h(ProductUsage, {
                  key: `report-single__product-usage__key`,
                  id: 'report__product-usage',
                  className: 'col-ratio-1 card--in-row',
                  content: content.product_usage,
                  title: content.product_usage.title,
                  tooltip: content.product_usage.tooltip,
                  graphs: content.product_usage.graphs,
                  hasProductMetricsHistory,
                  productMetrics: productMetrics,
                  productMetricsPrev: productMetricsPrev,
                  gsuiteMetrics:
                    this.getProductWeeklyValues(productMetrics),
                  gsuiteMetricsPrev:
                    this.getProductWeeklyValues(productMetricsPrev, true),
                  products: gsuite.products,
                  totalNumUsers: this.state.totalNumUsers,
                  totalNumUsersPrev: this.state.totalNumUsersPrev,
                  noDataError: globalContent.errors.noData,
                }, null),
                h(ChromebookDevices, {
                  key: `report-single__chromebooks-devices__key`,
                  id: 'report__chromebooks-devices',
                  className: 'col-ratio-1 card--in-row',
                  title: content.chromebooks_devices.title,
                  graphs: content.chromebooks_devices.graphs,
                  aue: content.chromebooks_devices.aue,
                  data: reportData.chromebooks_data,
                  reportDate: this.state.reportAvailableDate,
                  noDataError: globalContent.errors.noData,
                }, null),
                h(ProgramAdvancement, {
                  key: `report-single__program-advancement__key`,
                  id: 'report__program-advancement',
                  className: 'col-ratio-1 card--in-row',
                  title: content.program_advancement.title,
                  tooltip: content.program_advancement.tooltip,
                  graphs: content.program_advancement.graphs,
                  data: reportData.program_metrics,
                  dataPrev: reportDataPrev.program_metrics,
                  districtMetrics: reportData.district_config,
                  districtMetricsPrev: reportDataPrev.district_config,
                  noDataError: globalContent.errors.noData,
                }, null),
              ]),

              h('div', {
                key: `report-single__product-usage-detail__key`,
                className: 'row',
              }, h(ProductUsageDetail, {
                id: 'report__product-usage-detail',
                className: 'col-ratio-1 card--in-row',
                tooltip: content.product_usage_detail.tooltip,
                title: content.product_usage_detail.title,
                subtitle: content.product_usage_detail.subtitle,
                resourcesHeadline:
                  content.product_usage_detail.resourcesHeadline,
                resources: content.product_usage_detail.resources,
                chartHelpText: content.chartHelpText,
                products: gsuite.products,
                hasProductMetricsHistory,
                data: this.getProductWeeklyValues(productMetrics),
                dataPrev: this.getProductWeeklyValues(productMetricsPrev, true),
                chartName: this.state.currWindow,
                chartNamePrev: this.state.prevWindow,
                noDataError: globalContent.errors.noData,
                dynamicGraphSize,
                screenWidth,
              }, null)),

              h('div', {
                key: `report-single__four-cs__key`,
                className: 'row',
              }, h(FourCs, {
                id: 'report__four-cs',
                className: 'col-ratio-1 card--in-row',
                title: content.four_cs.title,
                titleTooltip: content.four_cs.tooltip,
                sidebar: content.four_cs.sidebar,
                products: gsuite.products,
                hasProductMetricsHistory,
                data: productMetrics,
                districtMetrics: reportData.district_config,
                gsuiteMetrics: this.getProductWeeklyValues(productMetrics),
                noDataError: globalContent.errors.noData,
                dynamicGraphSize,
                currWindow: this.state.currWindow,
                prevWindow: this.state.prevWindow,
                screenWidth,
              }, null)),

              h('div', {
                key: `report-single__row-2__key`,
                className: 'row',
              }, [
                h(DriveUserProfiles, {
                  key: `report-single__drive-user-profiles__key`,
                  id: 'report__drive-user-profiles',
                  className: 'col-ratio-1 card--in-row',
                  title: content.drive_user_profiles.title,
                  subtitle: content.drive_user_profiles.subtitle,
                  subtitleTooltip: content.drive_user_profiles.tooltip,
                  icon: content.drive_user_profiles.icon,
                  icon_2x: content.drive_user_profiles.icon_2x,
                  tabs: content.drive_user_profiles.tabs,
                  products: gsuite.products,
                  totalNumUsers: this.state.totalNumUsers,
                  totalNumUsersPrev: this.state.totalNumUsersPrev,
                  hasProductMetricsHistory,
                  data: productMetrics,
                  dataPrev: productMetricsPrev,
                  noDataError: globalContent.errors.noData,
                  chartName: this.state.currWindow,
                  chartNamePrev: this.state.prevWindow,
                  dynamicGraphSize,
                  screenWidth,
                }, null),
                h(ClassroomActivity, {
                  key: `report-single__classroom-activity__key`,
                  id: 'report__classroom-activity',
                  className: 'col-ratio-1 card--in-row',
                  userStatus: this.props.userStatus,
                  numTeachers: reportData.district_config.num_teachers,
                  numStudents: reportData.district_config.num_students,
                  disabledContent: content.classroom_activity.disabled,
                  title: content.classroom_activity.title,
                  icon: content.classroom_activity.icon,
                  icon_2x: content.classroom_activity.icon_2x,
                  tabs: content.classroom_activity.tabs,
                  hasProductMetricsHistory,
                  data: productMetrics,
                  districtMetrics: reportData.district_config,
                  noDataError: globalContent.errors.noData,
                }, null),
              ]),

              h('div', {
                key: `report-single__program-advancement-detail__key`,
                className: 'row',
              }, h(ProgramAdvancementDetail, {
                key: `report-single__program-advancement__key`,
                id: 'report__program-advancement-detail',
                className: 'col-ratio-1 card--in-row',
                title: content.program_advancement_detail.title,
                graphs: content.program_advancement_detail.graphs,
                resources: content.program_advancement_detail.resources,
                data: reportData.program_metrics,
                dataPrev: reportDataPrev.program_metrics,
                districtMetrics: reportData.district_config,
                districtMetricsPrev: reportDataPrev.district_config,
                noDataError: globalContent.errors.noData,
              }, null)),
              h(BasicCard, {
                className: 'card col-ratio-1 card--in-row margin-bottom--md',
              }, [
                h('div', {
                  id: 'report-footer',
                }, [
                  h(h4, {
                    className: 'p padding-bottom--sm padding-top--sm eyebrow',
                  }, content.analytics.title),
                  h(footnote, {
                    // eslint-disable-next-line max-len
                    className: 'chromebooks-devices__aue text--grey text--small',
                  },
                  [
                    content.analytics.desc1,
                    h('a', {
                      href: content.analytics.link,
                      id: 'report-footer__desc',
                      target: '_blank',
                      className: 'footnote aue-link text--blue',
                    },
                    'Click here',
                    ),
                    content.analytics.desc2,
                  ]),
                ]),
              ]),

              surveyDateClosed ? h('div', {
                key: 'report-single__transformation-progress-detail__key',
                className: 'row',
              }, h(TransformationProgressDetail, {
                id: 'report__transformation-progress-detail',
                className: 'col-ratio-1 card--in-row',
                title: transformationProgContent.title,
                survey_results_labels:
                  transformationProgContent.survey_results_labels,
                title_alt: transformationProgContent.title_alt,
                subhead_detail: transformationProgContent.title_alt,
                transformationElements:
                transformationProgContent.transformation_elements,
                elementSteps: transformationProgContent.element_steps,
                surveyResults: reportData.survey_results,
                surveyResultsPrev: reportDataPrev.survey_results,
                chartName: reportData.report_name,
                chartNamePrev: reportDataPrev.report_name,
                chartHelpText: content.transformation_progress.helpText,
                hasSurveyResults,
                transformationResources: this.state.transformationResources,
                errorMessage: content.transformation_progress.errorMessage,
                reportAvailableDate:
                  this.state.reportData.report_available_date,
              }, null)) : h('div', {
                key: 'report-single__transformation-progress-detail__key',
                className: 'row',
              }, h(SurveyStatus, {
                id: 'report__transformation-progress-detail',
                className: 'col-ratio-1 card--in-row margin-bottom--md',
                userStatus: this.props.userStatus,
                title: surveyStatusContent.title,
                subtitle: surveyStatusContent.subtitle,
                ctas: surveyStatusContent.ctas,
                surveyTitle: this.state.surveyStatus.survey_name,
                shareUrl: this.state.surveyStatus.share_survey_url,
                latestReport: this.state.latestReport,
                csrf: this.props.csrf,
                idToken: this.props.idToken,
              }, null)),
            ]),
          ])
        );
      }
    } else {
      return (
        h(LoadingIndicator, {
          title: this.state.loadingContent.title,
          subtitle: this.state.loadingContent.subtitle,
        }, null)
      );
    }
  }
}

export default ReportCardSingle;
